export default {
  methods: {
    uuid() {
      return crypto.getRandomValues(new Uint32Array(4)).join('-');
    },
    randomString() {
      return Math.random()
        .toString(36)
        .substring(2, 15) + Math.random()
        .toString(36)
        .substring(2, 15);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
};
